import React from "react";

const SolutionComponent = (props) => {
  const { solutionData: data, pageKey } = props;

  const baseStyle = {
    fontFamily: "'Times New Roman', Times, serif",
    fontSize: '16px',
  };

  return (
    <>
      {pageKey == 0 && (
        <div
          className="motionCompactPrintText"
          style={{
            pageBreakInside: "avoid",
            breakInside: "avoid",
            marginTop: "0.4rem",
            marginBottom: "0.2rem",
            paddingBottom: "0.2rem",
            ...baseStyle,
          }}
        >
          <div className="row answerFont">
            <div className="col-1" style={{ textAlign: "right" }}>{data.display_number}.</div>
            <div className="col-11">
              <b>Answer:</b> {data.answer}
            </div>
          </div>
          <div className="row">
            <div className="col-1"></div>
            <div className="col-11 row">
              <div className="col-5">
                <b>Sol:</b>
                <div dangerouslySetInnerHTML={{ __html: data.sol_text }} />
              </div>
              <div className="col-2"></div>
              <div className="col-5">
                <div
                  dangerouslySetInnerHTML={{ __html: data.sol_text_hindi }}
                  style={{ fontSize: '14px' }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {pageKey == 1 && (
        <div
          className="d-flex align-items-baseline gap-1 answerFont motionCompactPrintText"
          style={{
            pageBreakInside: "avoid",
            breakInside: "avoid",
            width: "95%",
            marginTop: "0.5rem",
            marginBottom: "0.5rem",
            paddingBottom: "0.5rem",
            paddingLeft: '1.3rem',
            ...baseStyle,
          }}
        >
          <b style={{ textAlign: "right" }}>{data.display_number}.</b>
          <div>
            <div><b>Answer:</b> {data.answer}</div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{ __html: data.sol_text }}
              style={{ fontSize: '14px' }}
            />
          </div>
        </div>
      )}

      {pageKey == 2 && (
        <div
          className="d-flex align-items-baseline gap-3 motionCompactPrintText"
          style={{
            pageBreakInside: "avoid",
            breakInside: "avoid",
            width: "95%",
            marginTop: "0.4rem",
            paddingBottom: "0.5rem",
            ...baseStyle,
          }}
        >
          <b style={{ textAlign: "right" }}>{data.display_number}.</b>
          <div>
            <div><b>Answer:</b> {data.answer}</div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{ __html: data.sol_text_hindi }}
              style={{ fontSize: '14px' }}
            />
          </div>
        </div>
      )}

      {pageKey == 5 && (
        <div
          className="d-flex align-items-baseline gap-3 answerFont motionCompactPrintText"
          style={{
            pageBreakInside: "avoid",
            breakInside: "avoid",
            width: "95%",
            marginTop: "0.5rem",
            marginBottom: "0.5rem",
            paddingBottom: "0.5rem",
            ...baseStyle,
          }}
        >
          <b style={{ textAlign: "right" }}>{data.display_number}.</b>
          <div>
            <div
              dangerouslySetInnerHTML={{ __html: data.q_text }}
              style={{ fontSize: '14px' }}
            />
            {data.eng_option &&
              data.eng_option.split("@").map((option, index) => (
                <div key={index} className="col-md-12 col-sm-12 col-xs-12 d-flex gap-2 mb-2">
                  <p>{`(${String.fromCharCode(65 + index)})`}</p>
                  <div dangerouslySetInnerHTML={{ __html: option }} />
                </div>
              ))}
            <div><b>Answer:</b> {data.answer}</div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{ __html: data.sol_text_hindi }}
              style={{ fontSize: '14px' }}
            />
          </div>
        </div>
      )}

      {(pageKey == 3 || pageKey == 4) && (
        <div
          className="d-flex align-items-baseline gap-3 answerFont motionCompactPrintText"
          style={{
            pageBreakInside: "avoid",
            breakInside: "avoid",
            width: "95%",
            marginTop: "0.4rem",
            paddingBottom: "1rem",
            ...baseStyle,
          }}
        >
          <b style={{ textAlign: "center" }}>{data.display_number}.</b>
          <div>
            <div><b>Answer:</b> {data.answer}</div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{ __html: data.sol_text_hindi }}
              style={{ fontSize: '14px' }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SolutionComponent;
